import isNil from "lodash/isNil";
// eslint-disable-next-line import-x/no-named-as-default -- react-datepicker exports DatePicker as default
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "@/crossPlatform/DateTimePicker/dateTimePicker.web.css";

interface DateTimePickerComponentProps {
  // eslint-disable-next-line react/no-unused-prop-types -- mirrors native picker API; consumer passes it
  display?: string;
  maximumDate?: Date;
  mode: DateTimePickerMode;
  // eslint-disable-next-line max-params -- matches @react-native-community/datetimepicker API
  onChange: (event: unknown, date?: Date) => void;
  // eslint-disable-next-line react/no-unused-prop-types -- mirrors native picker API; consumer passes it
  style?: Record<string, unknown>;
  // eslint-disable-next-line react/no-unused-prop-types -- mirrors native picker API; consumer passes it
  themeVariant?: string;
  value: Date;
}

const DateTimePickerComponent = ({
  maximumDate,
  mode,
  onChange,
  value,
}: DateTimePickerComponentProps) => {
  const handleChange = (date: Date | null) => {
    if (isNil(date)) return;
    onChange(undefined, date);
  };

  const isTimeMode = mode === "time";

  return (
    <DatePicker
      inline
      maxDate={isTimeMode ? undefined : maximumDate}
      onChange={handleChange}
      selected={value}
      showTimeInput={mode !== "date"}
      showTimeSelectOnly={isTimeMode}
    />
  );
};

export { DateTimePickerComponent };
